export default __webpack_public_path__ + "static/media/game-1.71fe9312.png";